const MIN_LATENCY_MS = 80;
const MAX_LATENCY_MS = 300;

export function simulateLatency(): Promise<void> {
  const delay = MIN_LATENCY_MS + Math.random() * (MAX_LATENCY_MS - MIN_LATENCY_MS);
  return new Promise(resolve => setTimeout(resolve, delay));
}
